import { DateTime } from 'luxon'

import { deepSetObject, digObject } from '@domain-group/javascript-utils'

import type { AgencyModel } from '@models/types'
import { EntitiesState } from '@redux/entities'

export const filterAgencySubscriptionStatus = (
  agency: AgencyModel,
  filterSubscriptionStatus?: 'active' | 'inactive',
) => {
  const { subscription_fee } = agency

  if (filterSubscriptionStatus === 'active'){
    return !!subscription_fee
  } if (filterSubscriptionStatus === 'inactive'){
    return !subscription_fee
  }
  return true
}

export const filterAgencyContractStatus = (
  agency: AgencyModel,
  contracts: EntitiesState['contracts'] = {},
  filterContractStatus?: 'current' | 'expiring_soon' | 'expired' | 'no_contracts',
) => {
  if (!filterContractStatus) return true

  const agencyContractIds: number[] = digObject(agency, 'contract_ids', [])

  // No Contracts
  if (!agencyContractIds.length && filterContractStatus === 'no_contracts') return true

  const today = DateTime.now()

  switch (filterContractStatus){
    case 'current':
      return agencyContractIds.some((id) => {
        const contract = contracts[id]
        return contract
        // @ts-expect-error TS2339
        && today >= DateTime.fromISO(contract.start_date)
        // @ts-expect-error TS2339
        && today <= DateTime.fromISO(contract.expiry_date)
      })
    case 'expiring_soon':
      return agencyContractIds.some((id) => {
        const contract = contracts[id]
        return contract
        // @ts-expect-error TS2339
        && DateTime.fromISO(contract.expiry_date) >= today
        // @ts-expect-error TS2339
        && DateTime.fromISO(contract.expiry_date) <= today.plus({ days: 90 })
      })
    case 'expired':
      return !agencyContractIds.some((id) => {
        const contract = contracts[id]
        return contract
        // @ts-expect-error TS2339
        && today >= DateTime.fromISO(contract.start_date)
        // @ts-expect-error TS2339
        && today <= DateTime.fromISO(contract.expiry_date)
      })
    default:
      return true
  }
}

export const filterAgencyByPortalIdentityCode = (
  agency: AgencyModel,
  agencyPortals: EntitiesState['agencyPortals'],
  string: string,
) => {
  if (!string) return true

  const agencyPortalIds: number[] = digObject(agency, 'portal_ids', [])

  return agencyPortalIds.some((portalId) => {
    const agencyPortal = agencyPortals[portalId] || {}
    return agencyPortal.identity_code?.toLowerCase() === string?.toLowerCase()
  })
}

export const mapAgencyToState = (agency: AgencyModel) => {
  // This is to correct display of pricing terms - it previously defaulted to 1 day
  const paymentTermsValue = digObject(agency, 'options.payment_terms_value', '')
  return paymentTermsValue ? agency : deepSetObject(agency, 'options.payment_terms_unit', 'months')
}
